import {useDispatch, useSelector} from 'react-redux'
import Table from '../../core/table'
import TextHelper from '../../../utils/text'
import {useEffect} from 'react'
import {getTeamIncidentsWithQuery} from '../../../stores/incident-management'
import renderSkeletonLoaders from '../../../utils/loader'
import NotFound from '../../../views/resources/NotFound'
import {GoodNewsIcon} from '../../../icons'
import './index.scss'
import classNames from 'classnames'
import {ImgButton} from '../../core/button'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../../routes'
import NavigationHelper from '../../../utils/navigation'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import {DateFormats, formatDate} from '../../../utils/date'

const IncidentsModal = ({resourceType, resourceId, isModal = true}) => {
    const text = useNamespaceTranslations('resource-incidents')
    const incidentsText = useNamespaceTranslations('incidents')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const {isFetching, teamIncidents} = useSelector(state => state.incident_management)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const generateDate = date => formatDate(date, DateFormats.DASH_YMD_TIME_SHORT)

    const tableHeader = [
        {label: incidentsText.urgency, className: 'min-width-150'},
        {label: incidentsText.name_placeholder, className: 'min-width-250'},
        {label: incidentsText.description_placeholder, className: 'min-width-400'},
        {label: incidentsText.status, className: 'min-width-150'},
        {label: incidentsText.created_at, className: 'min-width-150'},
        {label: incidentsText.updated_at, className: 'min-width-150'}
    ]

    const tbodyData = teamIncidents?.map((item) => {
        const createdAt = generateDate(item?.created_at)
        const updatedAt = generateDate(item?.updated_at)
        return [
            <span className="min-width-150">
                <span className={classNames(`badge urgency ${item?.urgency} capitalize`, {
                    dark: isDarkMode
                })}>{item?.urgency}</span>
            </span>,
            <span className="min-width-250" title={item?.name}>
                {TextHelper.textLengthChecker(item?.name, 60) || '-'}
            </span>,
            <span className="min-width-400" title={item?.description}>
                {TextHelper.textLengthChecker(item?.description, 60) || '-'}
            </span>,
            <span className="min-width-150">
                <span className={classNames(`badge status ${item?.status} capitalize`, {
                    dark: isDarkMode
                })}>{item?.status}</span>
            </span>,
            <span className="min-width-150">
                {createdAt}
            </span>,
            <span className="min-width-150">
                {updatedAt === createdAt ? text.not_available : updatedAt}
            </span>
        ]
    })

    const seeMoreIncidents = () => {
        const lastCreatedAt = teamIncidents?.reduce((prev, current) => {
            const prevDate = new Date(prev?.created_at)
            const currentDate = new Date(current?.created_at)
            return prevDate < currentDate ? prev : current
        })?.created_at
        navigate(`${NavigationHelper.getLocalizedPath(routes.incidents.paths)}?resource_type=${resourceType || ''}&resource_id=${resourceId || ''}&last_created_at=${lastCreatedAt || ''}`)
    }

    useEffect(() => {
        if (resourceId) {
            dispatch(getTeamIncidentsWithQuery(resourceId, resourceType))
        }
    }, [resourceId])

    return (
        <div className={classNames('incidents-container', {
            dark: isDarkMode
        })}>
            {isFetching ? <span className='incidents-loader'>{renderSkeletonLoaders(isModal ? 10 : 6)}</span> :
                teamIncidents?.length > 0 ? (
                    <>
                        <Table
                            tableHeader={tableHeader}
                            tbodyData={tbodyData}
                            data={teamIncidents}
                            hasCheckbox={false}
                            isMultiCheckable={false}
                            isScrollable={teamIncidents?.length > 10}
                        />
                        <ImgButton
                            onClick={seeMoreIncidents}
                            type="button"
                            className='load-button'
                        >
                            {text.see_more}
                        </ImgButton>
                    </>
                ) : <NotFound
                    message={text.no_incidents_found}
                    icon={<GoodNewsIcon className="good-news-icon"/>}/>}
        </div>
    )
}

export default IncidentsModal
